import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import AppLoader from '@/components/common/AppLoader';
import WhiteLabel from '@/components/WhiteLabel';
import { apiIsServiceStatusLoadingSelector, isSalesWorkingSelector, } from '@/models/api/selectors';
import NotWorking from './notWorking';
const WhiteLabelPage = () => {
    const isSalesWorking = useSelector(isSalesWorkingSelector);
    const apiIsServiceStatusLoading = useSelector(apiIsServiceStatusLoadingSelector);
    if (apiIsServiceStatusLoading) {
        return _jsx(AppLoader, {});
    }
    if (!isSalesWorking) {
        return _jsx(NotWorking, {});
    }
    return _jsx(WhiteLabel, {});
};
export default WhiteLabelPage;
